import QueryGreenWaysView from '../query/green-ways/QueryGreenWaysView';
import QueryBeachesView from '../query/beaches/QueryBeachesView';
import QueryWaysStJamesView from '../query/ways-st-james/QueryWaysStJamesView';
import QueryNationalParksView from '../query/national-parks/QueryNationalParksView';
import QueryProtectedAreasView from '../query/protected-areas/QueryProtectedAreasView';
import QueryPOIView from '../query/poi/QueryPOIView';
import QueryTouristRoutesView from '../query/tourist-routes/QueryTouristRoutesView';
import QueryTownsView from '../query/towns/QueryTownsView';
import QueryPhotosView from '../query/photos/QueryPhotosView';
import QueryServiceAreasView from '../query/service-areas/QueryServiceAreasView';
import QueryMountainPortsView from '../query/mountain-ports/QueryMountainPortsView';
import QueryPublicWorksView from '../query/public-works/QueryPublicWorksView';
import MapLayout from '@/templates/MapLayout';

export default [
  // Green Ways
  {
    path: '/query/green-ways',
    name: 'queryGreenWays',
    component: QueryGreenWaysView,
    meta: {
      title: 'Vías verdes/Rutas Ciclistas',
      layout: MapLayout,
      isSlim: true,
      materialIcon: 'nature_people',
    },
  },
  // Beaches
  {
    path: '/query/beaches',
    name: 'queryBeaches',
    component: QueryBeachesView,
    meta: {
      title: 'Playas',
      layout: MapLayout,
      isSlim: true,
      materialIcon: 'beach_access',
    },
  },
  // Ways of St James
  {
    path: '/query/ways-st-james',
    name: 'queryWaysStJames',
    component: QueryWaysStJamesView,
    meta: {
      title: 'Caminos de Santiago',
      layout: MapLayout,
      isSlim: true,
      materialIcon: 'hiking',
    },
  },
  // National Parks
  {
    path: '/query/national-parks',
    name: 'queryNationalParks',
    component: QueryNationalParksView,
    meta: {
      title: 'Parques nacionales',
      layout: MapLayout,
      isSlim: true,
      materialIcon: 'forest',
    },
  },
  // Protected Areas
  {
    path: '/query/protected-areas',
    name: 'queryProtectedAreas',
    component: QueryProtectedAreasView,
    meta: {
      title: 'Espacios protegidos',
      layout: MapLayout,
      isSlim: true,
      materialIcon: 'eco',
    },
  },
  // POI
  {
    path: '/query/poi',
    name: 'queryPOI',
    component: QueryPOIView,
    meta: {
      title: 'Lugares de interés',
      layout: MapLayout,
      isSlim: true,
      materialIcon: 'visibility',
    },
  },
  // Tourist routes
  {
    path: '/query/tourist-routes',
    name: 'queryTouristRoutes',
    component: QueryTouristRoutesView,
    meta: {
      title: 'Rutas turísticas',
      layout: MapLayout,
      isSlim: true,
      materialIcon: 'tour',
    },
  },
  // Towns
  {
    path: '/query/towns',
    name: 'queryTowns',
    component: QueryTownsView,
    meta: {
      title: 'Poblaciones',
      layout: MapLayout,
      isSlim: true,
      materialIcon: 'location_city',
    },
  },
  // Photos
  {
    path: '/query/photos',
    name: 'queryPhotos',
    component: QueryPhotosView,
    meta: {
      title: 'Fotos',
      layout: MapLayout,
      isSlim: true,
      materialIcon: 'photo_camera',
    },
  },
  // Service Areas
  {
    path: '/query/service-areas',
    name: 'queryServiceAreas',
    component: QueryServiceAreasView,
    meta: {
      title: 'Áreas de servicio',
      layout: MapLayout,
      isSlim: true,
      materialIcon: 'local_gas_station',
    },
  },
  // Mountain Ports
  {
    path: '/query/mountain-ports',
    name: 'queryMountainPorts',
    component: QueryMountainPortsView,
    meta: {
      title: 'Puertos de montaña',
      layout: MapLayout,
      isSlim: true,
      materialIcon: 'landscape',
    },
  },
  // Public Works
  {
    path: '/query/public-works',
    name: 'queryPublicWorks',
    component: QueryPublicWorksView,
    meta: {
      title: 'Obras públicas',
      layout: MapLayout,
      isSlim: true,
      materialIcon: 'account_balance',
    },
  },
];
